export default "images/calibration.png";